import { Map, fromJS } from 'immutable';

export function request(state, { id }) {
    let items = state.get('items') || Map();
    items = items.set(
        id,
        items.get(id).set('_state', 'IN_PROGRESS')
    );

    return state.set('items', items);
}

export function error(state, { id, errors }) {
    let items = state.get('items') || Map();

    items = items.set(
        id,
        items.get(id)
            .set('_state', 'ERROR')
            .set('errors', fromJS(errors))
    );

    return state.set('items', items);
}

export function finish(state, { id, data }) {
    data._state = 'FINISHED';

    if (data.cashoutMarketSettings) {
        for (const value in data.cashoutMarketSettings) {
            data.cashoutMarketSettings[value] = data.cashoutMarketSettings[value] !== 0 ? +data.cashoutMarketSettings[value] / 100 : null;
        }
    }

    return state.setIn([ 'items', id ], fromJS(data));
}

export function bulk(state, action) {
    let items = state.get('items');

    action.data.forEach(template => {
        const item = items.get(template.id) || Map();

        if (template.cashoutMarketSettings) {
            for (const value in template.cashoutMarketSettings) {
                template.cashoutMarketSettings[value] = template.cashoutMarketSettings[value] !== 0 ? +template.cashoutMarketSettings[value] / 100 : null;
            }
        }

        items = items.set(template.id, item.merge(template));
    });

    return state.set('items', items);
}
